import { render, staticRenderFns } from "./TournamentStage.vue?vue&type=template&id=47e6b963&"
import script from "./TournamentStage.vue?vue&type=script&lang=js&"
export * from "./TournamentStage.vue?vue&type=script&lang=js&"
import style0 from "./TournamentStage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports